<div class="backwrap gradient">
    <div class="back-shapes">
        <!-- <span class="floating facebook"
        style="top:12%;left:14%;animation-delay:-0.85s;"></span>
    <span class="floating linkedin"
        style="top:21%;left:10%;animation-delay:-2.9s;"></span>
    <span class="floating instay"
        style="top:44%;left:22%;animation-delay:-3.25s;"></span>
    <span class="floating facebooky"
        style="top:18%;left:12%;animation-delay:-2.5s;"></span>
    <span class="floating insta"
        style="top:31%;left:58%;animation-delay:-1.05s;"></span> -->
        <!-- <span class="floating linkedin"
        style="top:15%;left:29%;animation-delay:-4.15s;"></span> -->
        <!-- <span class="floating facebooky"
        style="top:61%;left:53%;animation-delay:-1.55s;"></span>
    <span class="floating facebook"
        style="top:40%;left:12%;animation-delay:-3.1s;"></span> -->
        <span class="floating insta" style="top:76%;left:26%;animation-delay:-1.25s;"></span>
        <!-- <span class="floating instay"
        style="top:42%;left:75%;animation-delay:-3.35s;"></span> -->
        <span class="floating instay" style="top:37%;left:11%;animation-delay:-0.8s;"></span>
        <span class="floating linkediny" style="top:71%;left:63%;animation-delay:-1.35s;"></span>
        <span class="floating facebook" style="top:23%;left:4%;animation-delay:-1.9s;"></span>
        <span class="floating insta" style="top:30%;left:28%;animation-delay:-3.1s;"></span>
        <span class="floating instay" style="top:19%;left:82%;animation-delay:-0.85s;"></span>
        <span class="floating facebooky" style="top:72%;left:45%;animation-delay:-1.55s;"></span>
        <span class="floating linkediny" style="top:27%;left:21%;animation-delay:-3.1s;"></span>
        <span class="floating linkedin" style="top:27%;left:49%;animation-delay:-4.25s;"></span>
        <span class="floating linkedin" style="top:37%;left:84%;animation-delay:-0.9s;"></span>
        <span class="floating linkediny" style="top:55%;left:27%;animation-delay:-2.35s;"></span>
        <!-- <span class="floating facebooky"
        style="top:50%;left:55%;animation-delay:-2.05s;"></span> -->
        <!-- <span class="floating facebook"
        style="top:49%;left:13%;animation-delay:-2.5s;"></span> -->
        <span class="floating linkedin" style="top:5%;left:33%;animation-delay:-3.65s;"></span>
        <!-- <span class="floating facebooky"
        style="top:21%;left:27%;animation-delay:-3.25s;"></span> -->
        <span class="floating instay" style="top:3%;left:6%;animation-delay:-4.05s;"></span>
        <span class="floating linkediny" style=" top: 69%;left: 11%;animation-delay:-3.7s;"></span>
        <span class="floating instay" style="top:75%;left:4%;animation-delay:-3.7s;"></span>
        <span class="floating linkedin" style="top:55%;left:8%;animation-delay:-3.7s;"></span>
        <span class="floating linkediny" style="top:60%;left:42%;animation-delay:-2.65s;"></span>
        <span class="floating instay" style="top:52%;left:21%;animation-delay:-1.85s;"></span>
        <span class="floating facebook" style="top:52%;left:17%;animation-delay:-1.85s;"></span>
        <span class="floating insta" style="top:33%;left:75%;animation-delay:-0.65s;"></span>
        <span class="floating linkediny" style="top:23%;left:69%;animation-delay:-2.3s;"></span>
        <span class="floating facebooky" style="top:11%;left:88%;animation-delay:-0.1s;"></span>
        <span class="floating instay" style="top: 59%;left: 80%;animation-delay: -0.35s;"></span>
        <span class="floating facebooky" style="top:0%;left:26%;animation-delay:-2.85s;"></span>
        <span class="floating facebooky" style="top:78%;left:83%;animation-delay:-0.35s;"></span>
        <span class="floating insta" style="top:60%;left:93%;animation-delay:-0.65s;"></span>

        <span class="floating linkediny" style="top:74%;left:93%;animation-delay:-0.65s;"></span>

        <span class="floating linkediny" style="top:52%;left:70%;animation-delay:-0.8s;"></span>
        <span class="floating instay" style="top: 67%;left: 72%;animation-delay: 1.2s;"></span>
        <span class="floating instay" style="top:3%;left:19%;animation-delay:-4.3s;"></span>
        <span class="floating facebook" style="top:53%;left:63%;animation-delay:-1.4s;"></span>
        <span class="floating linkediny" style="top:14%;left:12%;animation-delay:-1.75s;"></span>
        <span class="floating facebook" style="top:2%;left:44%;animation-delay:-1.85s;"></span>
        <!-- <span class="floating linkediny"
        style="top:76%;left:39%;animation-delay:-3.95s;"></span> -->
        <span class="floating facebook" style="top:15%;left:93%;animation-delay:-1.05s;"></span>
        <!-- <span class="floating linkediny"
        style="top:61%;left:38%;animation-delay:-1.95s;"></span> -->
        <span class="floating facebooky" style="top:45%;left:55%;animation-delay:-1.65s;"></span>
        <span class="floating insta" style="top:42%;left:35%;animation-delay:-0.35s;"></span>
        <span class="floating linkediny" style="top:65%;left:42%;animation-delay:-1.35s;"></span>
        <span class="floating facebooky" style="top: 50%;left: 88%;animation-delay: 2.4s;"></span>
        <!-- <span class="floating linkedin"
        style="top:27%;left:22%;animation-delay:-1.55s;"></span> -->
        <span class="floating instay" style="top:8%;left:72%;animation-delay:-1.95s;"></span>
        <span class="floating facebook" style="top:18%;left:47%;animation-delay:-1.85s;"></span>
    </div>
</div>